import Dialog from '@mui/material/Dialog';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box } from '@mui/material';
import FormSelect from '../atoms/FormSelect';
import Button from '../atoms/Button';
import config from '../../config';
import axios from 'axios';
import PageHeader from '../molecules/PageHeader';
import { Link } from 'react-router-dom';
import { logActivity } from '../../helpers/logActivity.helper';
const MoveStudentDialog = ({
  onClose,
  student,
  open,
  sessions,
  setRemoteTrigger,
}) => {
  const handleClose = () => {
    onClose();
  };
  const handleNewSessionTime = () => {
    const newTime = document.getElementById('newSessionValue').value;
    const updateSessionData = new FormData();
    updateSessionData.append('mode', 'updateSessionWithStudent');
    updateSessionData.append('newSession', newTime);
    updateSessionData.append('student', student.student_id);
    updateSessionData.append('auth', localStorage.getItem('token'));
    let newSessionName;
    let oldSessionName = '(NONE)';

    sessions.forEach(session => {
      if (Number(newTime) === Number(session.id))
        newSessionName = session.session;
      if (Number(student.student_session_time) === Number(session.id))
        oldSessionName = session.session;
    });

    axios
      .post(config.SESSION_API, updateSessionData)
      .then(output => {
        logActivity(
          `Moved student ${student.student_first_name} ${student.student_last_name} (${student.student_id}) from ${oldSessionName} to ${newSessionName}`
        );
        setRemoteTrigger(prev => prev + 1);
        onClose();
      })
      .catch(error => {
        console.error(error);
      });
  };
  const RightSideComponent = () => {
    return (
      <Link to={`/manage/students/${student.student_id}`}>View Student</Link>
    );
  };
  return (
    <Dialog onClose={handleClose} open={open} maxWidth='sm' fullWidth={true}>
      {!student ? (
        'No selected Student'
      ) : (
        <>
          <div className=' bg-primary-200 pl-4 pr-4 pt-4 shadow-sm'>
            <PageHeader
              RightSideComponent={RightSideComponent}
              testid='student-name-text'
            >
              {student.student_first_name} {student.student_last_name}
            </PageHeader>
          </div>
          <Box className='dialogBody'>
            <div className='mt-8 grid grid-cols-1 gap-2 sm:grid-cols-6 md:gap-6'>
              <div className='col-span-2 text-lg font-bold'>
                Current Session
              </div>
              <div className='col-span-4 mb-3 sm:mb-0'>
                {sessions.map(session => {
                  if (session.id == Number(student.student_session_time))
                    return (
                      <span key={student.student_id}>{session.session}</span>
                    );
                })}
              </div>

              <div className=' col-span-2 mt-4 text-lg font-bold md:mt-0'>
                Preferred Session
              </div>
              <div className='col-span-4 mb-3 sm:mb-0 sm:mt-4 md:mt-0'>
                {sessions.map(session => {
                  if (
                    session.id == Number(student.student_preferred_session_time)
                  )
                    return (
                      <span key={`session_${student.student_id}`}>
                        {session.session}
                      </span>
                    );
                })}
              </div>

              <div className='col-span-2 mt-4 text-lg font-bold md:mt-0'>
                New Session
              </div>
              <div className='col-span-4 mb-3 sm:mb-0 sm:mt-4 md:mt-0'>
                <FormSelect
                  propId='newSessionValue'
                  options={sessions}
                  valueKey='id'
                  labelKey='session'
                  ariaLabel='New Session'
                />
              </div>

              <div className='col-span-6 rounded-md border p-3'>
                <div className='text-lg font-bold'>
                  {student?.siblings?.length ? `Siblings` : `No Siblings`}
                </div>

                {student?.siblings?.map((sibling, index) => {
                  return (
                    <div key={index}>
                      {sibling.student_first_name} {sibling.student_last_name}{' '}
                      (LEVEL {sibling.student_level}, {sibling.session})
                    </div>
                  );
                })}
              </div>

              <div className='col-span-2 hidden sm:block'>&nbsp;</div>
              <div className='col-span-4 text-center sm:mt-2 sm:text-left'>
                <Button
                  callback={handleNewSessionTime}
                  testid='move-student-button'
                >
                  Save
                </Button>
              </div>
            </div>

            <Grid2 container>
              <Grid2 xs={4}>&nbsp;</Grid2>

              <Grid2 xs={8}></Grid2>
            </Grid2>
          </Box>
        </>
      )}
    </Dialog>
  );
};

export default MoveStudentDialog;
